import Dropdown from "@components/Dropdown/dropdown-component";
import { DropdownOption } from "@components/Dropdown/dropdown.types";
import { IconButton } from "@components/components";
import { Link, navigate } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";
import { FaBars } from "react-icons/fa";
import * as S from "./header-component.style";

const Header: React.FC = () => {
	const width = 104;
	const height = (width * 9) / 16;

	const options: DropdownOption[] = [
		{ value: "/provedor-de-contas/", label: "Provedor de contas" },
		{ value: "/baas/", label: "Bank as a Service (BaaS)" },
		{ value: "/maquininha/", label: "Maquininha (POS)" },
	];

	const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(false);

	const onMenuClick = () => setIsMenuOpen((prev) => !prev);
	const onNavClick = (route: string) => {
		navigate(route);
		setIsMenuOpen(false);
	};
	const handleSelect = (selectedValue: string) => navigate(selectedValue);

	return (
		<S.HeaderWrapper>
			<S.Header>
				<S.HeaderContainer>
					<Link to="/">
						<StaticImage
							src="../../assets/images/BeCash_LogoEscuro_1.webp"
							alt="Logo da BeCash"
							placeholder="blurred"
							height={height}
							width={width}
						/>
					</Link>
					<S.HeaderNav>
						<S.HeaderMainListItem>
							<Link to="/">Ínicio</Link>
						</S.HeaderMainListItem>
						<S.HeaderMainListItem>
							<Link to="/#quem-somos">Quem somos</Link>
						</S.HeaderMainListItem>
						<S.HeaderMainListItem>
							<Dropdown
								placeholder="Serviços"
								options={options}
								onSelect={handleSelect}
							/>
						</S.HeaderMainListItem>
						<S.HeaderMainListItem>
							<Link to="/#diferenciais">Diferenciais</Link>
						</S.HeaderMainListItem>
					</S.HeaderNav>
					<div />
					<S.HeaderMenuButtonContainer>
						<IconButton icon={<FaBars />} onClick={onMenuClick} />
					</S.HeaderMenuButtonContainer>
				</S.HeaderContainer>
			</S.Header>

			{isMenuOpen && (
				<S.HeaderNavDrawer $isOpen={isMenuOpen}>
					<S.HeaderNavMobile>
						<S.HeaderMainListItem onClick={() => onNavClick("/")}>
							Ínicio
						</S.HeaderMainListItem>
						<S.HeaderMainListItem onClick={() => onNavClick("/#quem-somos")}>
							Quem somos
						</S.HeaderMainListItem>
						<S.HeaderMainListItem onClick={() => onNavClick("/#diferenciais")}>
							Diferenciais
						</S.HeaderMainListItem>
						<S.HeaderMainListItem
							onClick={() => onNavClick("/provedor-de-contas/")}
						>
							Provedor de contas
						</S.HeaderMainListItem>
						<S.HeaderMainListItem onClick={() => onNavClick("/baas/")}>
							Bank as a Service (BaaS)
						</S.HeaderMainListItem>
						<S.HeaderMainListItem onClick={() => onNavClick("/maquininha")}>
							Maquininha (POS)
						</S.HeaderMainListItem>
					</S.HeaderNavMobile>
				</S.HeaderNavDrawer>
			)}
		</S.HeaderWrapper>
	);
};

export default Header;
